module.exports = __webpack_public_path__ + "static/media/ZIM.1bdbd749.svg";